require('./bootstrap');
import {ajustadorVideo} from "./modules/videos";
import {createElementFromHTML, equalheight} from "./modules/helpers";
import Swiper, {Navigation} from 'swiper';
import {SolicitudAviso} from "./modules/solicitud-aviso";

Swiper.use([Navigation]);

const imagenPrincipal = document.querySelector(".imagen-principal");
const ctrsVideo = document.querySelectorAll(".ctr-video");

const galeria = document.querySelector(".galeria.swiper");
const $selecVariantes = document.querySelector('.cesta-agregar-full select[name="variante_id"]');

const moverCarruselAVariante = (varianteId) => {
    const $imagen = document.querySelector(".galeria img[data-variante='" + varianteId + "']");
    if ($imagen && swiperGaleria) {
        // Obtengo el indice del padre de la imagen
        const indice = Array.from($imagen.parentElement.parentElement.children).indexOf($imagen.parentElement);
        swiperGaleria.slideTo(indice);
    }
}

let swiperGaleria = null;
if (galeria) {
    swiperGaleria = new Swiper(".galeria.swiper", {
        slidesPerView: 1,
        autoHeight: true,
        spaceBetween: 0,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    });

    if ($selecVariantes) {
        moverCarruselAVariante($selecVariantes.value);
    }
}

let ajustadorVideos = () => {
    ctrsVideo.forEach((el) => {
        ajustadorVideo(el);
    })
}

window.addEventListener('resize', ajustadorVideos)

ajustadorVideos();

let $close = createElementFromHTML('<div class="close">\n' +
    '        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '            <path d="M21 1.8375L19.1625 0L10.5 8.6625L1.8375 0L0 1.8375L8.6625 10.5L0 19.1625L1.8375 21L10.5 12.3375L19.1625 21L21 19.1625L12.3375 10.5L21 1.8375Z" fill="white"/>\n' +
    '        </svg>\n' +
    '    </div>');

let $imagenAmpliada = createElementFromHTML('<img class="imagen" src="" alt=""/>');

let $lightBoxGaleria = createElementFromHTML('<div class="lightbox-galeria"></div>');

$lightBoxGaleria.append($imagenAmpliada);
$lightBoxGaleria.append($close);

document.body.append($lightBoxGaleria);

if (imagenPrincipal) {
    imagenPrincipal.addEventListener("click", (e) => {
        if (e.target && e.target.hasAttribute("data-imagen")) {
            let imagen = e.target.getAttribute("data-imagen");
            $imagenAmpliada.setAttribute('src', imagen);
            $lightBoxGaleria.classList.add("abierto");
        }
    });
}


$lightBoxGaleria.addEventListener("click", (e) => {
    $lightBoxGaleria.classList.remove("abierto");
});

let  $precio= document.querySelector("[data-precio]");
let $precioFinal = document.querySelector("[data-precio-final]");

/* global preciosVariantes */
if ($selecVariantes) {
    $selecVariantes.addEventListener("change", (e) => {
        const varianteId = e.target.value;
        if (preciosVariantes) {
            if ($precio) {
                $precio.innerHTML = preciosVariantes[varianteId].precio;
            }

            if ($precioFinal) {
                $precioFinal.innerHTML = preciosVariantes[varianteId].precio_final;
            }
        }

        moverCarruselAVariante(varianteId);
    });
}

/* Relacionados */
let carruselSimilares = document.querySelector(".similares .swiper");

if (carruselSimilares) {
    new Swiper(carruselSimilares, {
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        breakpoints: {
            400: {
                slidesPerView: 2,
                spaceBetween: 5,
                slidesPerGroup: 10,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 10,
                slidesPerGroup: 3,
            },
            1280: {
                slidesPerView: 6,
                spaceBetween: 20,
                slidesPerGroup: 6,
            },
        },
        navigation: {
            nextEl: carruselSimilares.parentElement.querySelector(".swiper-button-next"),
            prevEl: carruselSimilares.parentElement.querySelector(".swiper-button-prev")
        },
        on: {
            afterInit: function () {
                equalheight(carruselSimilares.querySelectorAll(".producto"))
            },
            beforeResize: function () {
                equalheight(carruselSimilares.querySelectorAll(".producto"))
            }
        }
    });
}

new SolicitudAviso();
